import React from 'react'
import { Moon, Sun, Monitor } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useTheme } from '@/components/theme-provider'

export function ModeToggle() {
  const { theme, setTheme } = useTheme()

  const cycleTheme = () => {
    if (theme === 'light') {
      setTheme('dark')
    } else if (theme === 'dark') {
      setTheme('system')
    } else {
      setTheme('light')
    }
  }

  const themeConfig = {
    light: { icon: Sun, label: 'Light', next: 'Switch to dark mode' },
    dark: { icon: Moon, label: 'Dark', next: 'Switch to auto mode' },
    system: { icon: Monitor, label: 'Auto', next: 'Switch to light mode' }
  }

  const config = themeConfig[theme as keyof typeof themeConfig] || themeConfig.system
  const IconComponent = config.icon

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground hidden sm:block">
        {config.label}
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={cycleTheme}
        aria-label={config.next}
        title={config.next}
        className="h-8 w-8 p-0"
      >
        <IconComponent className="h-4 w-4" />
      </Button>
    </div>
  )
} 